"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @ts-check

var NON_ACTIONABLE_POLICY_TYPES = ["unspecified", "no-refund", "no-exchange"];

exports.default = NON_ACTIONABLE_POLICY_TYPES;
module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy92Mi9ub24tYWN0aW9uYWJsZS1wb2xpY3ktdHlwZXMuanMiXSwibmFtZXMiOlsiTk9OX0FDVElPTkFCTEVfUE9MSUNZX1RZUEVTIl0sIm1hcHBpbmdzIjoiOzs7OztBQUFBOztBQUVBLElBQU1BLDhCQUE4QixDQUFDLGFBQUQsRUFBZ0IsV0FBaEIsRUFBNkIsYUFBN0IsQ0FBcEM7O2tCQUVlQSwyQiIsImZpbGUiOiJub24tYWN0aW9uYWJsZS1wb2xpY3ktdHlwZXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAdHMtY2hlY2tcblxuY29uc3QgTk9OX0FDVElPTkFCTEVfUE9MSUNZX1RZUEVTID0gW1widW5zcGVjaWZpZWRcIiwgXCJuby1yZWZ1bmRcIiwgXCJuby1leGNoYW5nZVwiXTtcblxuZXhwb3J0IGRlZmF1bHQgTk9OX0FDVElPTkFCTEVfUE9MSUNZX1RZUEVTO1xuIl19